import { useMemo } from 'react';
import useRangeFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useRangeFilter';
import { createRangeSchema } from '@/creditflowresearch/ui/common/hooks/sidebar/rangeSchema';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const useAttrition = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const schema = useMemo(() => createRangeSchema({ bounds: filters?.attrition }), [filters?.attrition]);

  return useRangeFilter({ fromKey: 'includedAttritionFrom', toKey: 'includedAttritionTo', schema });
};

export default useAttrition;
